import { render } from "./AccountTypeUpdate.vue?vue&type=template&id=f0c7f282&scoped=true"
import script from "./AccountTypeUpdate.vue?vue&type=script&lang=js"
export * from "./AccountTypeUpdate.vue?vue&type=script&lang=js"

import "./AccountTypeUpdate.vue?vue&type=style&index=0&id=f0c7f282&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0c7f282"]])

export default __exports__